export default class PersistFlag {
    static No_Persist = 0;
    static Persist = 1;
    static Persist_And_Count = 3;
    static Transparent = 4;
}


// WEBPACK FOOTER //
// ./src/fscommon/websocket/message/persistFlag.js